import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { faqs } from '../../mock';

export default function FAQ() {
  return (
    <section className="py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <div className="text-center">
          <div className="brand-divider mx-auto mb-5" />
          <h2 className="font-display text-4xl md:text-5xl font-semibold text-stone-900 leading-tight">
            Frequently asked questions
          </h2>
          <p className="mt-4 text-stone-600 text-[17px]">
            Got a question? Chances are it&apos;s here. If not, just ask away.
          </p>
        </div>

        <Accordion type="single" collapsible className="mt-10 space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-stone-200 rounded-2xl px-5 bg-white data-[state=open]:border-[#0b6b5b]/40 data-[state=open]:shadow-md"
            >
              <AccordionTrigger className="font-display text-left text-lg text-stone-900 hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-stone-600 text-[15px] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
